
export const environment = {
   production: false,
   apiUrl: "https://l5uchr0lo9.execute-api.us-east-1.amazonaws.com/dev/contactPeople",
   apiKey: "qw3wprgXl3ancX3dtke9V6XoRNZMYUcG3Nf8EDZq",
   COGNITO_TOKEN_URL: "https://l5uchr0lo9.execute-api.us-east-1.amazonaws.com/dev/getAuthToken",
   ipifyUrl: "https://api.ipify.org?format=json"
};
